<template>
  <router-link :to="{ name: 'Article', params: {article: formatLink(path) } }">
    <figure :class="[$options.name, 'Box']">
      <span :class="$options.name + '__wrap'">
        <img :alt="'Hero image for ' + title" :src="src + '?fm=jpg&fl=progressive&f=faces&fit=fill&w=960&h=540'">
      </span>
      <figcaption :class="$options.name + '__caption'">
        <h3>{{ title }}</h3>
      </figcaption>
    </figure>
  </router-link>
</template>
<script>
export default {
  name: "NewsItem",
  methods: {
    formatLink(value) {
      return value.toLowerCase().replace(/[^A-Za-z0-9']/g, "");
    }
  },
  props: {
    path: { default: "/" },
    src: { default: "" },
    title: { default: "NewsItem" }
  }
};
</script>
<style lang="scss">
.NewsItem {
  display: inline-block;
  padding: 0;
  &__wrap {
    display: block;
  }
  &__caption {
    border-top: rem(1) solid var(--base-ghost);
    margin-top: 0;
    padding: rem(16);
    text-align: center;
  }
}
</style>